import React, { useContext, useState } from 'react';
import { PostContext } from '../../../context/DataContext'; 
import UsePost from '../../../components/hook/UsePost';
import Header from '../../../components/navegation/header/Header';
import Footer from '../../../components/navegation/footer/Footer';
import Main from '../../../components/interface/main/Main';
import HotelsAccordion from './HotelsAccordion';
import HotelsHeader from './HotelsHeader';
import OrganizersElement from '../../../components/design/organizers/OrganizersElement';
import UseTimeOut from '../../../components/hook/UseTimeOut';
import './hotels.css'
import UseLangLocation from '../../../components/hook/UseLangLocation';
import SponsorsSlider from '../../../components/sections/sponsors/SponsorsSlider';
import StickyHeader from '../../../components/interface/sticky-header /StickyHeader';

const Hotels = props => { 
    const { handleID, title, handleApiURL, handleLoading, status, accordion } = useContext(PostContext);
    const [loading, setLoading] = useState(true);

    return (
        <UseLangLocation>
            <UsePost enabled handleApiURL={handleApiURL} url='https://apievt.lacnic.net/wp-json/wp/v2/travel' handleLoading={handleLoading} handleID={handleID} id='862'>
                <Header title={title} loading={loading} url_en='/en/hotels-and-travel/hotels' url_es='/es/hoteles-y-viaje/hoteles' url_pt_br='/pt-br/hoteis-e-viagem/hoteis' {...props} />
                <Main className='container main_hotels' loading={loading} status={status}>
                    <section>
                        <UseTimeOut timeout='700' loading={loading} setLoading={setLoading} title={title}>
                             
                            <SponsorsSlider/>
                            <StickyHeader/>
                            <HotelsHeader title={title} />
                            <HotelsAccordion accordion={accordion} />
                        </UseTimeOut>
                    </section>
                </Main>
                <OrganizersElement />
                <Footer className="master_foot foot_home" />
            </UsePost>
        </UseLangLocation>
    )
}

export default Hotels
